import { useContext } from "react"
import styled from "styled-components"
import FeaturesList from "components/car/FeaturesList"
import { color } from "helpers/styled"
import { CarContext } from "../CarContext"

const Background = styled.div`
  border-bottom: 1px solid ${color("lightGray")};
`

export default function Features() {
  const { car } = useContext(CarContext)

  return (
    <Background>
      <FeaturesList car={car} />
    </Background>
  )
}
